import React, { useState } from "react";
import useCollapse from "react-collapsed";
import { Card, Button } from "react-bootstrap";

const Commerce = () => {
  const [isExpanded, setExpanded] = useState(false);
  const { getCollapseProps, getToggleProps } = useCollapse();

  return (
    <div className="subjectcards">
      <Card
        className="subject-card"
        style={{
          boxShadow: "10px 8px 4px rgba(0, 0, 0, 0.25)",
          border: "6px solid rgba(244, 59, 0, 0.63)",
        }}
      >
        <div
          className="subject-card-header"
          style={{
            background: "rgba(244, 59, 0, 0.91)",
            border: "6px solid rgba(244, 59, 0, 0.63)",
          }}
        >
          <p className="subject-card-heading">
            <b>Commerce</b>
          </p>
        </div>
        <Card.Body className="subject-card-body">
          <div>
            <Card.Title>Compulsory Subjects</Card.Title>
            <Card.Body className="subject-card-section-body">
              <ul>
                <li>English Core</li>
                <li>Accountancy</li>
                <li>Business Studies</li>
                <li>Economics</li>
              </ul>
            </Card.Body>
          </div>
          <div {...getCollapseProps()}>
            <Card.Title>Optional Subjects</Card.Title>
            <Card.Body className="subject-card-section-body">
              <p className="subject-card-note">(Choose any one)</p>
              <ul>
                <li>Computer Science</li>
                <li>Physical Education</li>
                <li>Painting</li>
              </ul>
              <p className="subject-card-note">(Choose any one)</p>
              <ul>
                <li>Tourism</li>
                <li>AI</li>
                <li>Mathematics</li>
              </ul>
            </Card.Body>
          </div>
        </Card.Body>
        <Button
          className="subject-card-button"
          {...getToggleProps({
            onClick: () => setExpanded((prevExpanded) => !prevExpanded),
          })}
          style={{
            border: "none",
            backgroundColor: "#081b24",
          }}
        >
          {isExpanded ? "Read Less" : "Read More"}
        </Button>
      </Card>
    </div>
  );
};

export default Commerce;
